import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, useRefresh, useRedirect, showNotification } from "react-admin";
import axios from "axios";
import { Fragment } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

class AddImpiantoButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      impianto_inserito: (
        props.record !== undefined
          ? props?.record?.hasOwnProperty("impianto_inserito")
          : false
      )
        ? props.record.impianto_inserito
        : false,
      loading: false,
    };
  }

  importaImpianto = () => {
    const { record } = this.props;

    console.log(record);
    this.setState({ loading: true });

    axios
      .get(window.BaseURL + `/gse/checkStatus`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth")}`,
        },
      })
      .then((response) => {
        console.log(response);
        if (response !== undefined && response?.data?.status === 0) {
          alert(
            "Un altro impianto è in fase di caricamento. Attendere che il processo finisca per continuare"
          );
          this.setState({ loading: false });
        } else {
          axios
            .post(window.BaseURL + `/gse/addImpianto/`, record, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("auth")}`,
              },
            })
            .then((response) => {
              this.setState({ loading: false });
              alert(
                "L'impianto è stato correttamente inviato a mysolar per essere processato"
              );
              window.location = "/gse";
            })
            .catch(function (error) {
              alert(`Non è stato possibile importare l'impianto.\n${error}`);
              this.setState({ loading: false });
              console.log(error);
            });
        }
      });
  };

  render() {
    return (
      <Fragment>
        {!this.state.impianto_inserito && (
          <Button
            label="Importa Impianto"
            style={{ background: "#3f51b5", color: "white" }}
            size="medium"
            onClick={(e) => {
              e.stopPropagation();
              this.importaImpianto();
            }}
          >
            {this.state.loading && (
              <CircularProgress
                style={{ color: "white" }}
                size={18}
                thickness={5}
              />
            )}
          </Button>
        )}
      </Fragment>
    );
  }
}

AddImpiantoButton.propTypes = {
  record: PropTypes.object,
};

export default connect(null, {})(AddImpiantoButton);
